import React, { useState } from "react";
import { HelpCircleIcon, ChevronDownIcon, ChevronUpIcon } from "./HelpCenterIcons";

const FAQ_ITEMS = [
  {
    q: "How do I add a new gym member?",
    a: "To add a new gym member, navigate to the Members section in the sidebar, click on 'Add Member' button, fill in the required details including name, contact information, and membership plan, then click Save. The new member will be immediately added to your system.",
  },
  {
    q: "How can I generate reports?",
    a: "Go to the Reports section in the sidebar. You can generate various reports including revenue reports, member activity reports, and attendance reports. Select the report type, choose the date range, and click Generate.",
  },
  {
    q: "How do I manage membership plans?",
    a: "Navigate to the Membership Plans section. From there you can create new plans, edit existing ones, set pricing and duration, and activate or deactivate plans as needed.",
  },
  {
    q: "How can I track daily sales?",
    a: "The Dashboard provides a real-time overview of daily sales. For detailed sales tracking, visit the Sales section where you can filter by date range, payment method, and membership type.",
  },
  {
    q: "How do I change my password?",
    a: "Go to Settings > Account tab. Under the Change Password section, enter your current password, then enter and confirm your new password. Click Update Password to save the changes.",
  },
  {
    q: "Can I export member data?",
    a: "Yes, navigate to the Members section and click the Export button. You can export member data in CSV or Excel format. You can also filter members before exporting to get specific data sets.",
  },
];

const HelpCenterFAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (idx) => {
    setOpenIndex((prev) => (prev === idx ? null : idx));
  };

  return (
    <div className="v2-help-pg-card">
      <div className="v2-help-pg-card__header">
        <div className="v2-help-pg-card__icon-wrap" style={{ background: "#fef2f2" }}>
          <HelpCircleIcon size={20} color="#eb1414" />
        </div>
        <div>
          <h3 className="v2-help-pg-card__title">Frequently Asked Questions</h3>
          <p className="v2-help-pg-card__subtitle">
            Common questions about using the platform
          </p>
        </div>
      </div>

      <div className="v2-help-pg-faq-list">
        {FAQ_ITEMS.map((item, idx) => {
          const isOpen = openIndex === idx;
          return (
            <div
              className={`v2-help-pg-faq-item${isOpen ? " v2-help-pg-faq-item--open" : ""}`}
              key={idx}
            >
              <button
                className="v2-help-pg-faq-item__question"
                onClick={() => toggle(idx)}
              >
                <span>{item.q}</span>
                {isOpen ? (
                  <ChevronUpIcon size={18} color="#6b7280" />
                ) : (
                  <ChevronDownIcon size={18} color="#6b7280" />
                )}
              </button>
              {isOpen && (
                <div className="v2-help-pg-faq-item__answer">
                  <p>{item.a}</p>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default HelpCenterFAQ;
